// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { currencyConfig } from '../../../config/currency.config';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AccountingSystemAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingSystemAccounts';
        this.Server =
            this.props.context.getState().server.accountingSystemAccounts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'description', 'currency'];

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'currency',
                label: 'currency',
                alignRight: false,
                cell: 'Items',
                type: 'currency',
                noTranslate: true,
                items: Object.keys(currencyConfig),
                displayGrid: true
            },
            {
                id: 'balance',
                label: 'balance',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName',
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            }
        ];

        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
